export default __webpack_public_path__ + "static/media/footer_instagram.ee78800b.svg";